(function (Translator) {
    // xk
    Translator.add("address", "Adresa:", "PayseraMapBundle", "xk");
    Translator.add("friday", "E premte", "PayseraMapBundle", "xk");
    Translator.add("monday", "E h\u00ebn\u00eb", "PayseraMapBundle", "xk");
    Translator.add("no_results", "Nuk jan\u00eb gjetur rezultate", "PayseraMapBundle", "xk");
    Translator.add("saturday", "E shtun\u00eb", "PayseraMapBundle", "xk");
    Translator.add("search_placeholder", "Jepni nj\u00eb fragment", "PayseraMapBundle", "xk");
    Translator.add("service.cash_in", "Cash-in", "PayseraMapBundle", "xk");
    Translator.add("service.cash_out", "Cash-out", "PayseraMapBundle", "xk");
    Translator.add("service.identification", "Identifikimi", "PayseraMapBundle", "xk");
    Translator.add("service.pay", "Pagesat", "PayseraMapBundle", "xk");
    Translator.add("services", "Sh\u00ebrbimet:", "PayseraMapBundle", "xk");
    Translator.add("sunday", "E diel", "PayseraMapBundle", "xk");
    Translator.add("thursday", "E enjte", "PayseraMapBundle", "xk");
    Translator.add("tuesday", "E mart\u00eb", "PayseraMapBundle", "xk");
    Translator.add("wednesday", "E m\u00ebrkur\u00eb", "PayseraMapBundle", "xk");
    Translator.add("working_hours", "Or\u00ebt e pun\u00ebs:", "PayseraMapBundle", "xk");
})(Translator);
